import { FunctionComponent, useRef, useState } from 'react'
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  rucksack,
  TextField,
  Typography,
} from '@black-bear-energy/rucksack'
import { BoldText } from './BoldText'
import { CloseRounded, CheckRounded } from '@mui/icons-material'
import { CenteredModal } from '../CenteredModal'
import { useReviewChecklistDocument } from '../../api/hooks/useReviewChecklistDocument'

export const ReviewDocumentModal: FunctionComponent<
  ReviewDocumentModalProps
> = ({ open, documentId, documentName, handleClose }) => {
  const { mutate: reviewChecklistDocument } = useReviewChecklistDocument()
  const [verify, setVerify] = useState(true)
  const textInputRef = useRef<HTMLInputElement>(null)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVerify(event.target.value === 'true')
  }

  const handleSave = () => {
    const comment = textInputRef.current?.value
    reviewChecklistDocument({
      documentId,
      documentName,
      verify,
      comment,
    })
    handleClose()
  }

  return (
    <CenteredModal open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          alignSelf: 'stretch',
        }}
      >
        <Typography variant="h6">Review Document</Typography>
        <IconButton onClick={handleClose}>
          <CloseRounded />
        </IconButton>
      </Box>
      <Typography variant="body1">
        You are reviewing <BoldText>{documentName}</BoldText> document(s).
      </Typography>
      <RadioGroup value={verify} onChange={handleChange} row>
        <FormControlLabel
          value="true"
          control={<Radio />}
          label="Verify"
          sx={{ '&.Mui-checked': { color: rucksack.palette.primary.main } }}
        />
        <FormControlLabel value="false" control={<Radio />} label="Reject" />
      </RadioGroup>
      <TextField
        inputRef={textInputRef}
        fullWidth
        multiline
        label="Comment"
      ></TextField>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: '14px',
          alignSelf: 'stretch',
        }}
      >
        <Button
          sx={{
            color: rucksack.palette.primary.dark,
            border: '1px solid rgba(73, 173, 214, 0.50)',
            padding: '6px 16px',
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          startIcon={<CheckRounded />}
          sx={{
            backgroundColor: rucksack.palette.primary.light,
            borderRadius: rucksack.shape.borderRadius,
            color: rucksack.palette.primary.contrastText,
            fontSize: '14px',
            fontWeight: 500,
            padding: '6px 14px',
            boxShadow:
              '0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20);',
          }}
        >
          Save Review
        </Button>
      </Box>
    </CenteredModal>
  )
}

export interface ReviewDocumentModalProps {
  open: boolean
  documentId: number
  documentName: string
  handleClose: () => void
}
